import { render, staticRenderFns } from "./GeneratePDFButton.vue?vue&type=template&id=50ba8d97&scoped=true&"
import script from "./GeneratePDFButton.vue?vue&type=script&lang=js&"
export * from "./GeneratePDFButton.vue?vue&type=script&lang=js&"
import style0 from "./GeneratePDFButton.vue?vue&type=style&index=0&id=50ba8d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba8d97",
  null
  
)

export default component.exports